/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tools_Legajox_Absence_Detail_SuccessInputs */

const es_tools_legajox_absence_detail_success = /** @type {(inputs: Tools_Legajox_Absence_Detail_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detalle de ausencia de Legajox consultado`)
};

const en_tools_legajox_absence_detail_success = /** @type {(inputs: Tools_Legajox_Absence_Detail_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legajox absence detail queried`)
};

/**
* | output |
* | --- |
* | "Legajox absence detail queried" |
*
* @param {Tools_Legajox_Absence_Detail_SuccessInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tools_legajox_absence_detail_success = /** @type {((inputs?: Tools_Legajox_Absence_Detail_SuccessInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tools_Legajox_Absence_Detail_SuccessInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tools_legajox_absence_detail_success(inputs)
	return en_tools_legajox_absence_detail_success(inputs)
});
export { tools_legajox_absence_detail_success as "tools.legajox.absence_detail_success" }